import { render } from "./AppAlert.vue?vue&type=template&id=70d31ac0&scoped=true"
import script from "./AppAlert.vue?vue&type=script&lang=js"
export * from "./AppAlert.vue?vue&type=script&lang=js"

import "./AppAlert.vue?vue&type=style&index=0&id=70d31ac0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d31ac0"]])

export default __exports__